import React, { useEffect, useState } from "react";
import { useParams,useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "./CoachingVideo.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { Modal } from "react-bootstrap";

const CoachingVideo = () => {
	const { id } = useParams();
	const [loading,setLoading] = useState(true);
	
	const [show, setShow] = useState(false);
	const [inputs, setInputs] = useState({name:''});
	const [course, setCourse] = useState([]);
	const [trailerid, setTrailerid] = useState('');
	const [traileridmo, setTraileridmo] = useState('');
	const [cid, setCid] = useState(0);

	const navigate = useNavigate();
	const savedCart = localStorage.getItem("cartItems");
	const [cartItems, setCartItems] = useState(JSON.parse(savedCart) || []);

	const [showimg, setShowimg] = useState(0);

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
		document.title = `Coaching Video | Your Friend My Friend`;
		document.getElementById('bodywrap').className = 'products';

		localStorage.removeItem("prev_page");
		 localStorage.removeItem("checkout_data");

		/* Start get course data */
		let formData = new FormData();
		formData.append('id', id);
			var url='get_course';
      if(localStorage.getItem('auth_token'))
      {
        url='get_course_with_login';
      }
	    API.post(url,formData)
	      .then(response => {
	        setLoading(false);
	      if(response.data.status === false){
	        
	      }else{
	         setCourse(response.data.data.course_data);
	         setInputs({name:response.data.data.coach_name});
	      }                  
	    }).catch(error => {
	       setLoading(false);
	    });  
	   /* End get course data */

	     

	    if(parseInt(id)===1){
	    	setShowimg(1);
	    }else{
	    	setShowimg(2);
	    }

	}, [id]);

useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
    console.log(cartItems);
  }, [cartItems]);

  const addToCart = (product) => {
    const existingItem = cartItems.find((item) => item.id === product.id);

    if (existingItem) {
      setCartItems(
        cartItems.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      );
    } else {
      setCartItems([...cartItems, { ...product, quantity: 1 }]);
    }
  };
  const removeFromCart = (id) => {
    setCartItems(cartItems.filter((item) => item.id !== id));
  };
  
	const setShowtrailerid = (trailer_id,mobile_course_trailer_url,id) => {
      setTrailerid(trailer_id);
      setTraileridmo(mobile_course_trailer_url);
       setCid(id);
      setShow(true);
  }

	return (
		<>
			<Header isMasterClass={true} />
			<div className="hello-worldss hello-worldss-img  d-flex justify-content-center align-items-center position-relative">
  {showimg === 1 ? (
    <>
      <img
        src={process.env.REACT_APP_BASE_URL + 'assests/images/Annie-lavin-dating-masterclass.jpg'}
        alt="Coach Desktop"
        className="img-fluid omagu123 d-none d-md-block"
      />
      <img
        src={process.env.REACT_APP_BASE_URL + 'assests/images/Annie-lavin-dating-masterclass.jpg'}
        alt="Coach Mobile"
        className="img-fluid omagu123 d-block d-md-none"
      />
      {/*<div className="overlay-text-omag position-absolute text-center">
        <h1 className="mb-0">DATING</h1>
        <h1 className="mb-2">MASTERCLASS</h1>
        <p className="mb-0">SERIES</p>
      </div>*/}
    </>
  ) : showimg === 2 ? (
    <>
      <img
        src={process.env.REACT_APP_BASE_URL + 'assests/images/Brian-oLoughlin-dating-masterclass.png'}
        alt="Coach Desktop"
        className="img-fluid omagu123 d-none d-md-block"
      />
      <img
        src={process.env.REACT_APP_BASE_URL + 'assests/images/Brian-oLoughlin-dating-masterclass.png'}
        alt="Coach Mobile"
        className="img-fluid omagu123 d-block d-md-none"
      />
      {/*<div className="overlay-text-omag position-absolute text-center">
        <h1 className="mb-0">DATING</h1>
        <h1 className="mb-2">MASTERCLASS</h1>
        <p className="mb-0">SERIES</p>
      </div>*/}
    </>
  ) : null}
</div>
			<div className="container-fluid wiklo uhjks">
				<div className="row">
					{/* Left Section - Event Details */}
					<div className="col-lg-7 wiklo-left">
						<div className="d-flex gap-2 mb-3 flex-wrap">
							<h4>Coaching</h4>
						</div>
						<h2 className="mb-0">Dating Masterclass</h2>
						<h2>with {inputs.name}</h2>
						{course.map((val, i) => {
					  const isInCart = cartItems.some((item) => item.id === val.id);

					  return (<div className="boklus mt-4 p-0">
								<img
									src={val.image}
									alt="Masterclass"
									className="img-fluid mastuyt"
								/>

								<div className="p-4">
									<div className="hegupar">{val.name}</div>

									<p className="mb-3 chungaer">{val.description}</p>

									<div className="timinis">Relationship Coach: {inputs.name} | Time: {val.video_min} mins</div>

									<div className="d-flex gap-3 flex-wrap juma purch-his">
										<button className="sec-fra text-center" onClick={() => setShowtrailerid(val.trailer_video_url,val.mobile_course_trailer_url,val.id)}>
											Watch trailer
										</button>

										{/*{added[1] ? (
											<button className="mt-0 chuchuk">
												<img
													src={process.env.REACT_APP_BASE_URL + 'assests/images/right-df.png'}
													alt="Masterclass"
													className="img-fluid me-2 mb-1"
												/>
												added
											</button>
										) : (
											<button className="btn mt-0" onClick={() => addToCart({ id: val.id, name: val.name, price: val.price,coach_name:inputs.name })}>€{val.price} | ADD TO CART</button>
										)}*/}
										{isInCart ? (
										  val.is_booked === 0 ? (
										    <button className="mt-0 chuchuk">
										      <img
										        src={process.env.REACT_APP_BASE_URL + "assests/images/right-df.png"}
										        alt="Masterclass"
										        className="img-fluid me-2 mb-1"
										      />
										      added
										    </button>
										  ) : (
										    <button className="btn mt-0" onClick={() => navigate(`/master-class-video/${val.id}`)}>
										      Watch Masterclass
										    </button>
										  )
										) : (
										  val.is_booked === 0 ? (
										    <button
										      className="btn mt-0"
										      onClick={() =>
										        addToCart({
										          id: val.id,
										          name: val.name,
										          price: val.price,
										          coach_name: inputs.name,
										        })
										      }
										    >
										      €{val.price} | ADD TO CART
										    </button>
										  ) : (
										    <button className="btn mt-0" onClick={() => navigate(`/master-class-video/${val.id}`)}>
										      Watch Masterclass
										    </button>
										  )
										)}
									</div>
								</div>
							</div>)
						}
						)}
						
					</div>
				
					<div className="col-lg-1"></div>

					<div  className="col-lg-4 wiklo-right">
						<div className={`card new-man uma position-sticky ${
    cartItems.length > 0 ? "" : "cart-dis-box"
  }`}>
							{cartItems.length > 0 ? (
								<>
							 {cartItems.map((val, i) => (
								<div className="d-flex justify-content-between align-items-center gap-4 mb-4">
									<div>
										<h6>
											Dating Masterclass with {val.coach_name}
										</h6>
										<p>
											{val.name}
										</p>
									</div>
									<div className="krice">€{val.price}</div>
									<div className="cart-remove-box" onClick={() => removeFromCart(val.id)}>X</div>
								</div>
							 ))}	
							 </>
						 ) : (
						 		<div className="justify-content-between align-items-center gap-4 mb-4">
								<div>
									<p className="text-center">Your cart is empty.</p>
								</div>
							</div>
						 )}
							{/* Total Section */}
							<div className="d-flex justify-content-between align-items-start chun mb-3 totalbox">
								<span>Total</span>
								<div className="text-end">
									<div className="to-krice">€{cartItems
              .reduce((total, item) => total + parseFloat(item.price || 0), 0)
              .toFixed(2)}</div>
									<div className="insu">Price includes tax</div>
								</div>
							</div>
							<button className="btn w-100" onClick={() => navigate("/check-out-new")}>
								checkout
							</button>
						</div>
					</div>
				</div>
			</div>
			<Modal show={show} onHide={() => setShow(false)} centered size="lg" dialogClassName="custom-modal-nyt">
             <Modal.Header closeButton>Why modern women feel disconnected in love — and how to come home to yourself</Modal.Header>
              <Modal.Body className="text-center">
                <div className="position-relative mb-4">
                  <iframe
                    title="YouTube video player"
                  src={trailerid}
                 allow="fullscreen; encrypted-media"
                  allowFullScreen
                style={{
                border: 'none',
                borderRadius: '15px'
              }}
              className="pop-youtube-video d-none d-md-block"
                ></iframe>

                	<iframe
                    title="YouTube video player"
                  src={traileridmo}
                 allow="fullscreen; encrypted-media"
                  allowFullScreen
                style={{
                border: 'none',
                borderRadius: '15px'
              }}
              className="pop-youtube-video d-block d-md-none"
                ></iframe>
                  
                </div>

                <div className="d-flex justify-content-center gap-2 flex-wrap juma purch-his">
                  <button className="btn budha mt-0" onClick={() => navigate(`/master-class-video/${cid}`)}>
                    get masterclass
                  </button>
                </div>
              </Modal.Body>
            </Modal>
			{loading && (
		     <div className="loadingClass">
		      <img src={loader} alt="loader"/>
		    </div>
		     )}
			<Footer />
		</> 
	); 
};

export default CoachingVideo;
